import { fetchJSON } from '../utils/fetch'
import { Service, service, inject } from './di'
import { ConfigService } from './ConfigService'
import MetadataService from './MetadataService'
import { LocationService } from './LocationService'
import { FlyerService } from './FlyerService'
import { MerchantsDetails } from '../definitions/ApiDefinitions'

@service
export default class MerchantService extends Service {
    @inject configService: ConfigService
    @inject metadataService: MetadataService
    @inject flyerService: FlyerService
    @inject locationService: LocationService

    public async getMerchantDetails(
        merchantIds: string
    ): Promise<MerchantsDetails> {
        try {
            return await fetchJSON<MerchantsDetails>(
                `${this.configService.API_SERVER}/merchants/details?ids=${merchantIds}`
            )
        } catch (e) {
            return null
        }
    }

    public async getAllMerchants(locale: string): Promise<MerchantsDetails> {
        try {
            return await fetchJSON<MerchantsDetails>(
                `${this.configService.API_SERVER}/merchants?locale=${locale}`
            )
        } catch (e) {
            return null
        }
    }
}
